// extracted by mini-css-extract-plugin
export default {"employee-container":"PayPoint_employee-container__YKiD6"};